export enum LegalizationDocumentCategoryEnum {
  WorkLegalization = 1,
  StayLegalization = 2
}
